import yup from 'src/libs/yup';

const FunnelFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  status: yup.array().of(yup.string()).nullable().label('Status'),
});

export default FunnelFilterSchema;
